<template>
  <div>
    <v-row class="filters--list mb-4">
      <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
        <FilterSearch :fetchData="fetchBoard" searchTerm="searchText" />
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
        <FilterBoolean
          :fetchData="fetchBoard"
          :label="$t('filters.myAppointments')"
          type="realEstateOperatorAppointments"
        />
      </v-col>
      <v-col v-if="isAustralian" cols="12" sm="12" md="3" lg="3" class="pb-0">
        <FilterBoolean
          :fetchData="fetchBoard"
          :label="$t('filters.onlyNotConfirmed')"
          type="onlyNotConfirmed"
        />
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
        <FilterSelect
          :fetchData="fetchBoard"
          :label="$t('filters.dayOfWeek')"
          :items="[
            { label: $t('week.MONDAY'), value: 'MONDAY' },
            { label: $t('week.TUESDAY'), value: 'TUESDAY' },
            { label: $t('week.WEDNESDAY'), value: 'WEDNESDAY' },
            { label: $t('week.THURSDAY'), value: 'THURSDAY' },
            { label: $t('week.FRIDAY'), value: 'FRIDAY' },
            { label: $t('week.SATURDAY'), value: 'SATURDAY' },
            { label: $t('week.SUNDAY'), value: 'SUNDAY' },
          ]"
          item-value="value"
          item-text="label"
          type="dayOfWeek"
        />
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-autocomplete
          :value="boardServiceType"
          @change="setBoardServiceType"
          :items="serviceTypeItems"
          :label="$t('filters.serviceType')"
          single-line
          clearable
          outlined
          small
          dense
        />
      </v-col>
    </v-row>
    <div class="filters--list__loading" v-if="boardLoading">
      <v-progress-circular indeterminate color="white" width="2" size="18" />
    </div>
  </div>
</template>

<script>
import FilterBoolean from '@/components/filters/FilterBoolean'
import FilterSearch from '@/components/filters/FilterSearch'
import FilterSelect from '@/components/filters/FilterSelect'

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'BoardListFilters',

  components: {
    FilterBoolean,
    FilterSearch,
    FilterSelect,
  },

  data() {
    return {
      _interval: null,
    }
  },

  computed: {
    ...mapGetters(['boardLoading', 'boardServiceType', 'boardServiceTypeOptions']),

    isAustralian() {
      return localStorage.getItem('user_country') == 'AU'
    },

    isServiceProviderUser() {
      const userRole = localStorage.getItem('access_roles')

      if (!userRole) return false
      return userRole.includes('ROLE_SERVICE_PROVIDER')
    },

    serviceTypeItems() {
      return this.boardServiceTypeOptions
        .map((value) => ({ value, text: this.$t(`type.${value}`) }))
        .sort((itemA, itemB) => itemA.text.localeCompare(itemB.text))
    },
  },

  methods: {
    ...mapActions(['fetchBoard', 'fetchBoardContractServiceTypes']),
    ...mapMutations(['setBoardServiceType']),

    Timer(fn, time) {
      let timerObj = setInterval(fn, time)

      this.stop = function() {
        if (timerObj) {
          clearInterval(timerObj)
          timerObj = null
        }

        return this
      }

      this.start = function() {
        if (!timerObj) {
          this.stop()
          timerObj = setInterval(fn, time)
        }

        return this
      }
    },
  },

  beforeDestroy() {
    this._interval.stop()
  },

  mounted() {
    this.setBoardServiceType(null)

    // A service provider has no contract of its own; its options come from the board alone
    if (!this.isServiceProviderUser) this.fetchBoardContractServiceTypes()

    this._interval = new this.Timer(() => {
      this.fetchBoard()
    }, 10000)

    this._interval.start()
  },
}
</script>
